import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { TableConfig } from 'src/app/shared/components/app-table/app-table-models';
import { AnvandareDTO, OrganisationDTO } from './anvandare.models';
import { AnvandareService } from './anvandare.service';
import { SessionService } from 'src/app/auth/services/session.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizationService } from 'src/app/auth/services/authorization.service';
import { Role } from 'src/app/pages/anvandare/anvandare.models';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'lib-anvandare',
  templateUrl: './anvandare.component.html',
  styleUrls: ['./anvandare.component.scss'],
  standalone: false,
})
export class AnvandareComponent implements OnInit {
  public authorizationService = inject(AuthorizationService);
  private anvandareService = inject(AnvandareService);
  private sessionService = inject(SessionService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private destroy = inject(DestroyRef);
  private isAdminRole: boolean = false;
  private allOrgs!: OrganisationDTO[];

  tableConfig: TableConfig = {
    multiSortMeta: undefined,
    columns: [
      { field: 'anvandarnamn', header: 'Användarnamn', sortByField: 'anvandarnamn', columnFilter: 'text' },
      { field: 'fornamn', header: 'Förnamn', sortByField: 'fornamn', columnFilter: 'text' },
      { field: 'efternamn', header: 'Efternamn', sortByField: 'efternamn', columnFilter: 'text' },
      { field: 'anvandartyp', header: 'AnvandarTyp', sortByField: 'anvandartyp', columnFilter: 'text' },
      {
        field: 'anvandareOrganisationer',
        header: 'KML',
        sortByField: 'organisation',
        columnFilter: 'text',
        mapView: (x) => this.mapKmlKod(x),
      },
      { field: 'skapad', header: 'Skapad', type: 'date', sortByField: 'skapad', columnFilter: 'text' },
      { field: 'epost', header: 'Epost', sortByField: 'epost', columnFilter: 'text' },
      {
        field: 'status',
        header: 'Status',
        sortByField: 'status',
        type: 'dropdown',
        dropdownOptions: [
          { value: 'Aktiv', label: 'Aktiv' },
          { value: 'EjAktiv', label: 'Ej aktiv' },
          { value: 'Sparrad', label: 'Spärrad' },
          { value: 'Registrerad', label: 'Registrerad' },
        ],
        click: (event: any) => this.updateAnvandare(event),
        columnFilter: 'multi-select',

        filterOptions: [
          { name: 'Aktiv', label: 'Aktiv' },
          { name: 'EjAktiv', label: 'Ej aktiv' },
          { name: 'Sparrad', label: 'Spärrad' },
          { name: 'Registrerad', label: 'Registrerad' },
        ],
        hide: !this.isAdminRole,
      },

      { field: '', type: 'editButton', click: (row) => this.goToDetails(row), hide: !this.isAdminRole },
    ],
  };

  anvandare: AnvandareDTO[] = [];

  mapKmlKod(x: any) {
    return x.map((y: any) => this.allOrgs.find(org => org.id === y.organisationId)?.labKod);
  }

  ngOnInit() {
    this.anvandareService
      .getAllOrganisations()
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe((orgs) => (this.allOrgs = orgs));
    this.anvandareService.listaAnvandare<AnvandareDTO[]>().subscribe((anvandare) => {
      this.anvandare = anvandare;
      this.tableConfig.rows = anvandare;
    });
    this.checkUserRole();
  }

  private goToDetails(row: AnvandareDTO) {
    this.router.navigate([row.id], { relativeTo: this.route, state: row });
  }

  updateAnvandare(user: AnvandareDTO) {
    this.anvandareService.updateAnvandare(user).subscribe((response) => {});
  }

  checkUserRole(): void {
    this.isAdminRole =
      this.authorizationService?.hasRole([
        Role.BehörighetsadministratörIntern,
        Role.Systemadministrator,
        Role.BehorighetsadministratorExtern,
      ]) ?? false;
    const isExternAdminRole = this.authorizationService?.hasRole([Role.BehorighetsadministratorExtern]) ?? false;

    this.tableConfig.columns =
      this.tableConfig.columns?.map((col) => {
        if (col.field === 'status') {
          return { ...col, hide: isExternAdminRole };
        }
        if (col.type === 'editButton') {
          return { ...col, hide: !this.isAdminRole };
        }
        return col;
      }) ?? [];

    this.tableConfig = { ...this.tableConfig };
  }
}
